import React from 'react';
import { useIntl } from 'react-intl';
import Select from 'react-select';
import PropTypes from 'prop-types';
import classes from './style.module.css';

const options = [
  { value: 'desc', label: 'Mais recente primeiro' },
  { value: 'asc', label: 'Mais antigo primeiro' },
];

const ClientFiltersBar = ({ activeStatus, orderByDir, onStatusChange, onOrderByDirChange }) => {
  const intl = useIntl();

  const handleStatusClick = (status, defaultDir) => {
    onStatusChange(status, defaultDir);
  };

  const handleOrderByDirChange = (e) => {
    onOrderByDirChange(e.value);
  };

  const btnClass = (status) => `${classes.filterButton} ${activeStatus === status ? classes.activeFilter : ''}`;

  return (
    <div className={classes.content}>
      <nav className={classes.clientsFiltersBar}>
        <button
          type="button"
          className={btnClass('all')}
          onClick={() => handleStatusClick('all', 'desc')}
          data-cy="all-orders-tab"
        >
          {intl.formatMessage({ id: 'ALL_INSPECTIONS' })}
        </button>
        <button
          type="button"
          className={btnClass('waiting')}
          onClick={() => handleStatusClick('waiting', 'asc')}
          data-cy="waiting-orders-tab"
        >
          {intl.formatMessage({ id: 'WAITING_INSPECTIONS' })}
        </button>
        <button
          type="button"
          className={btnClass('accepted')}
          onClick={() => handleStatusClick('accepted', 'asc')}
          data-cy="accepted-orders-tab"
        >
          {intl.formatMessage({ id: 'ACCEPTED_INSPECTIONS' })}
        </button>
        <button
          type="button"
          className={btnClass('assigned')}
          onClick={() => handleStatusClick('assigned', 'asc')}
          data-cy="assigned-orders-tab"
        >
          {intl.formatMessage({ id: 'ASSIGNED_INSPECTIONS' })}
        </button>
        <button
          type="button"
          className={btnClass('in_progress')}
          onClick={() => handleStatusClick('in_progress', 'asc')}
          data-cy="in-progress-orders-tab"
        >
          {intl.formatMessage({ id: 'IN_PROGRESS_INSPECTIONS' })}
        </button>
        <button
          type="button"
          className={btnClass('finalized')}
          onClick={() => handleStatusClick('finalized', 'asc')}
          data-cy="finalized-orders-tab"
        >
          {intl.formatMessage({ id: 'FINISHED_INSPECTIONS' })}
        </button>
        <button
          type="button"
          className={btnClass('sent')}
          onClick={() => handleStatusClick('sent', 'desc')}
          data-cy="sent-orders-tab"
        >
          {intl.formatMessage({ id: 'SENT_INSPECTIONS' })}
        </button>
        <button
          type="button"
          className={btnClass('rejected')}
          onClick={() => handleStatusClick('rejected', 'desc')}
          data-cy="rejected-orders-tab"
        >
          {intl.formatMessage({ id: 'REJECTED_INSPECTIONS' })}
        </button>
        <button
          type="button"
          className={btnClass('canceled')}
          onClick={() => handleStatusClick('canceled', 'desc')}
          data-cy="canceled-orders-tab"
        >
          {intl.formatMessage({ id: 'CANCELED_INSPECTIONS' })}
        </button>
      </nav>
      <div className={classes.selectContainer}>
        <Select
          value={options.find(option => option.value === orderByDir) || options[0]}
          options={options}
          onChange={handleOrderByDirChange}
          isSearchable={false}
          styles={{
            control: base => ({
              ...base,
              minWidth: '175px',
              fontSize: '12px',
              minHeight: '32px',
              height: '2vw',
              maxHeight: '38px',
              borderColor: '#cccccc',
              boxShadow: 'none',
              '&:hover': {
                borderColor: '#bbbbbb',
              },
            }),
            valueContainer: base => ({
              ...base,
              padding: '0 8px',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
            }),
            singleValue: base => ({
              ...base,
              margin: 0,
              padding: 0,
            }),
            indicatorsContainer: base => ({
              ...base,
              height: '100%',
            }),
            dropdownIndicator: base => ({
              ...base,
              padding: '0 8px',
              display: 'flex',
              alignItems: 'center',
            }),
            option: base => ({
              ...base,
              fontSize: '12px',
            }),
          }}
        />
      </div>
    </div>
  );
};

ClientFiltersBar.propTypes = {
  activeStatus: PropTypes.string.isRequired,
  orderByDir: PropTypes.string.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onOrderByDirChange: PropTypes.func.isRequired,
};

export default ClientFiltersBar;
